<mpro-top-bar #topBar class="top-bar"></mpro-top-bar>
<mpro-freemium-pay-wall></mpro-freemium-pay-wall>
<div #stickyHeader class="sticky-header">
  <mpro-header id="first-step"></mpro-header>
</div>
<section #container class="container-xl">
  <div id="third-step">
    <mpro-consumer-spending-size-prize
      [isFromSizeOfPrize]="true"
    ></mpro-consumer-spending-size-prize>
  </div>
  <div class="innerContainer">
    <div id="fourth-step">
      <mpro-size-prize-chart
      ></mpro-size-prize-chart>
    </div>
    <div>
      <div id="fifth-step">
        <mpro-consumer-ranking
        ></mpro-consumer-ranking>
      </div>
      <div id="sixth-step">
        <mpro-top-consumer
        ></mpro-top-consumer>
      </div>
    </div>
  </div>
</section>
<div class="tooltip"></div>
